<template>
  <div class="plat-data-grid-grade"
       v-loading="loading"
       element-loading-text="数据加载中，请稍等...">
    <template v-if="grades">
      <template v-if="grades.length">
        <keep-alive>
          <TemplateDataGrid :key="grade"
                            ref="grid"
                            :gridId="gridId"
                            v-bind="gridParams"
                            v-on="$listeners">
            <template #title="{title}">
              <div class="plat-data-grid-grade-header">
                <span v-if="showLabel"
                      class="custom-label">年级</span>
                <el-select v-model="grade"
                           size="mini"
                           filterable>
                  <el-option v-for="grade in grades"
                             :key="grade.id"
                             :label="grade.name"
                             :value="grade.id"/>
                </el-select>
                <span v-if="showTitle"
                      class="custom-title">{{title}}</span>
                <div v-if="$slots.append"
                     class="append">
                  <slot name="append"></slot>
                </div>
              </div>
            </template>
          </TemplateDataGrid>
        </keep-alive>
      </template>
      <template v-else>
        <Hint type="empty">
          <div>年级数据为空</div>
        </Hint>
      </template>
    </template>
    <template v-else>
      <Hint v-if="!loading"
            type="error">
        <div>年级数据加载失败</div>
        <el-button type="text"
                   @click="loadGrades">重新加载</el-button>
      </Hint>
    </template>
  </div>
</template>

<script>
import TemplateDataGrid from '../../../../../templates/TemplateDataGrid'
import Hint from '../../../../../elements/Hint'
import Wrapper from '../../../../../../mixins/grid/wrapper'
export default {
  name: 'PlatDataGridGrade',
  mixins: [Wrapper],
  components: {
    TemplateDataGrid,
    Hint
  },
  props: {
    showLabel: Boolean,
    showTitle: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      loading: false,
      grades: null,
      grade: ''
    }
  },
  computed: {
    gridParams () {
      return {
        grade: this.grade
      }
    }
  },
  methods: {
    loadGrades () {
      this.loading = true
      this.$ajax({
        url: '/workspace/manager/portal/data/select/grades',
        method: 'post'
      }).then(response => {
        if (response.data) {
          this.grades = response.data['grades'] || []
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.loading = false
      })
    },
    loadGridData () {
      this.$nextTick(() => {
        let grid = this.$refs.grid
        if (grid) {
          grid.loadGridData()
        }
      })
    }
  },
  mounted () {
    this.loadGrades()
  },
  watch: {
    grades: function (val) {
      if (val && val.length) {
        let getGrade = val.find(grade => grade.active)
        if (!getGrade) {
          let lastGradeId = this.getWrapper('grade')
          if (lastGradeId) {
            getGrade = val.find(grade => grade.id === lastGradeId)
          }
        }
        if (getGrade) {
          this.grade = getGrade.id
        } else {
          this.grade = val[0].id
        }
      }
    },
    grade: function (val) {
      this.setWrapper('grade', val)
    },
    gridParams: {
      handler: function () {
        this.loadGridData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
  .plat-data-grid-grade {
    height: 100%;
    .plat-data-grid-grade-header {
      display: inline-flex;
      align-items: center;
      .el-select {
        width: 100px;
      }
      .custom-label {
        margin-right: 8px;
        font-size: 13px;
      }
      .custom-title {
        margin-left: 8px;
        font-size: 13px;
      }
    }
  }
</style>
